export * from './queryKeys';

/**
 * Follow-up type mapping
 * Maps follow-up action types to Dataverse dogma_type values
 * 1 = Callback
 * 2 = Email
 * 3 = SMS
 */
export const FOLLOWUP_TYPE_MAP: Record<string, 1 | 2 | 3> = {
  'callback': 1,
  'email': 2,
  'sms': 3,
  'set_date': 1, // Set date defaults to callback
};
